import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class CounterV1 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="ltn__counterup-area section-bg-1 pt-120 pb-70">
			  <div className="container">
			    <div className="row">
			      <div className="col-md-3 col-sm-6 align-self-center">
			        <div className="ltn__counterup-item text-color-white---">
			          <div className="counter-icon">
			            {/* <i className="flaticon-select" /> */}
						<img src={publicUrl+"assets/img/icons/icon-img/28.svg"} alt="#" style={{ width: '65px', height: '65px' }} />
			          </div>
			          <h1><span className="counter">60</span><span className="counterUp-icon">+</span><span className="counterUp-letter">Acres</span> </h1>
			          <h6>Project Area Developed</h6>
			        </div>
			      </div>
			      <div className="col-md-3 col-sm-6 align-self-center">
			        <div className="ltn__counterup-item text-color-white---">
			          <div className="counter-icon">
			            {/* <i className="flaticon-office" /> */}
						<img src={publicUrl+"assets/img/icons/icon-img/29.svg"} alt="#" style={{ width: '65px', height: '65px' }} />
			          </div>
			          <h1><span className="counter">800</span><span className="counterUp-letter"></span><span className="counterUp-icon">+</span> </h1>
			          <h6>Plots Successfully Sold</h6>
			        </div>
			      </div>
			      <div className="col-md-3 col-sm-6 align-self-center">
			        <div className="ltn__counterup-item text-color-white---">
			          <div className="counter-icon">
			            {/* <i className="flaticon-excavator" /> */}
						<img src={publicUrl+"assets/img/icons/icon-img/30.svg"} alt="#" style={{ width: '65px', height: '65px' }} />
			          </div>
			          <h1><span className="counter">6</span><span className="counterUp-icon">+</span> </h1>
			          <h6>Completed Layout Projects</h6>
			        </div>
			      </div>
			      <div className="col-md-3 col-sm-6 align-self-center">
			        <div className="ltn__counterup-item text-color-white---">
			          <div className="counter-icon">
			            {/* <i className="flaticon-armchair" /> */}
						<img src={publicUrl+"assets/img/icons/icon-img/31.svg"} alt="#" style={{ width: '65px', height: '65px' }} />
			          </div>
			          <h1><span className="counter">36</span><span className="counterUp-icon">+</span><span className="counterUp-letter">UNITS</span> </h1>
			          <h6>In Isiri Coconut Grove</h6>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default CounterV1